<terra-dialog-header>
  <h1 class="lo_sensitive" [innerHTML]="storageObject.displayName + '.' + storageObject.extension"></h1>
</terra-dialog-header>

<mat-dialog-content>
  <!-- Filestack viewer injected here (for documents/any file that can be converted to pdf, images also)   -->
  <div id="filePreviewFrame" *ngIf="mediaType !== MediaType.Video && mediaType !== MediaType.Audio"></div>
  <!-- HTML 5 players -->
  <ng-container *ngIf="mediaType === MediaType.Video || mediaType === MediaType.Audio">
    <ng-container *ngIf="isAudioOrVideoSupportedForPreview(storageObject, mediaType) else notSupported">
      <video *ngIf="mediaType === MediaType.Video" controls>
        <source [src]="fullUrlWithCredentials" [type]="storageObject.metaFileLink.mediaType">
        Your browser does not support this HTML5 video tag.
      </video>
      <audio *ngIf="mediaType === MediaType.Audio" controls>
        <source [src]="fullUrlWithCredentials" [type]="storageObject.metaFileLink.mediaType">
      </audio>
    </ng-container>
    <ng-template #notSupported>
      <div class="preview-not-supported">
        <p>No preview available, download the file directly.</p>
        <button mat-flat-button color="primary" (click)="download(storageObject)">
          <mat-icon class=" notranslate">get_app</mat-icon>
          Download file
        </button>
      </div>
    </ng-template>
  </ng-container>
</mat-dialog-content>

<div mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="undefined" class="close-button" color="primary" cdkFocusInitial>Close</button>
</div>
